import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, MapPin, Mail, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0f2e24] text-white pt-20 pb-10 border-t border-[#D4AF37]/20" data-id="element-31">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-33">
          {/* Brand */}
          <div data-id="element-34">
            <div className="flex items-center mb-8" data-id="element-35">
              <a href="#" className="block group mr-4 relative z-10" data-id="element-36">
                <div className="w-16 h-16 flex items-center justify-center transition-transform duration-300 ease-out group-hover:scale-[3] origin-center bg-transparent" data-id="element-37">
                  <img src="https://cdn.magicpatterns.com/uploads/1WRKNfF2etQMe5cv3dKkhu/This_is_the_logo.jpg" alt="Flicker Digital Africa" className="w-10 h-auto object-contain" data-id="element-38" />
                </div>
              </a>
              <span className="text-2xl font-serif font-bold tracking-tight text-white" data-id="element-39">
                Flicker Digital
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-8 font-light max-w-xs" data-id="element-40">
              We blend strategy, creativity, and data to build campaigns that
              capture attention and drive real results across Africa.
            </p>
            <div className="flex space-x-5" data-id="element-41">
              <a href="#" className="text-gray-400 hover:text-[#D4AF37] transition-colors transform hover:scale-110 duration-300" data-id="element-42">
                <Facebook size={20} data-id="element-43" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#D4AF37] transition-colors transform hover:scale-110 duration-300" data-id="element-44">
                <Twitter size={20} data-id="element-45" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#D4AF37] transition-colors transform hover:scale-110 duration-300" data-id="element-46">
                <Instagram size={20} data-id="element-47" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#D4AF37] transition-colors transform hover:scale-110 duration-300" data-id="element-48">
                <Linkedin size={20} data-id="element-49" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-50">
            <h4 className="text-lg font-serif font-semibold mb-8 text-[#D4AF37]" data-id="element-51">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-52">
              <li data-id="element-53">
                <a href="#about" className="text-gray-400 hover:text-white transition-colors text-sm tracking-wide" data-id="element-54">
                  About Us
                </a>
              </li>
              <li data-id="element-55">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors text-sm tracking-wide" data-id="element-56">
                  Our Services
                </a>
              </li>
              <li data-id="element-57">
                <a href="#team" className="text-gray-400 hover:text-white transition-colors text-sm tracking-wide" data-id="element-58">
                  Leadership
                </a>
              </li>
              <li data-id="element-59">
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors text-sm tracking-wide" data-id="element-60">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-61">
            <h4 className="text-lg font-serif font-semibold mb-8 text-[#D4AF37]" data-id="element-62">
              Expertise
            </h4>
            <ul className="space-y-4" data-id="element-63">
              <li className="text-gray-400 text-sm tracking-wide" data-id="element-64">
                Strategic Communications
              </li>
              <li className="text-gray-400 text-sm tracking-wide" data-id="element-65">
                Media Relations
              </li>
              <li className="text-gray-400 text-sm tracking-wide" data-id="element-66">
                Performance Marketing
              </li>
              <li className="text-gray-400 text-sm tracking-wide" data-id="element-67">
                Event Management
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-68">
            <h4 className="text-lg font-serif font-semibold mb-8 text-[#D4AF37]" data-id="element-69">
              Contact Us
            </h4>
            <ul className="space-y-6" data-id="element-70">
              <li className="flex items-start group" data-id="element-71">
                <MapPin className="h-5 w-5 text-[#D4AF37] mr-4 flex-shrink-0 group-hover:text-white transition-colors" data-id="element-72" />
                <span className="text-gray-400 text-sm font-light" data-id="element-73">
                  Nairobi, Kenya
                </span>
              </li>
              <li className="flex items-center group" data-id="element-74">
                <Mail className="h-5 w-5 text-[#D4AF37] mr-4 flex-shrink-0 group-hover:text-white transition-colors" data-id="element-75" />
                <a href="mailto:hello@flickerdigitalafrica.com" className="text-gray-400 hover:text-white transition-colors text-sm font-light" data-id="element-76">
                  hello@flickerdigitalafrica.com
                </a>
              </li>
              <li className="flex items-center group" data-id="element-77">
                <Phone className="h-5 w-5 text-[#D4AF37] mr-4 flex-shrink-0 group-hover:text-white transition-colors" data-id="element-78" />
                <span className="text-gray-400 text-sm font-light" data-id="element-79">
                  +254 729 892780
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#D4AF37]/20 pt-8 text-center flex flex-col md:flex-row justify-between items-center" data-id="element-80">
          <p className="text-gray-500 text-xs tracking-wider uppercase mb-4 md:mb-0" data-id="element-81">
            &copy; {new Date().getFullYear()} Flicker Digital Africa. All rights
            reserved.
          </p>
          <div className="flex space-x-6" data-id="element-82">
            <a href="#" className="text-gray-500 hover:text-[#D4AF37] text-xs uppercase tracking-wider transition-colors" data-id="element-83">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-500 hover:text-[#D4AF37] text-xs uppercase tracking-wider transition-colors" data-id="element-84">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}